<fieldset [formGroup]="form" class="easy-form">
  <legend class="small-legend">
    {{ "SHARED.LOCALIZED_MARKETING_SUBFORM.TITLE" | translate }}:
  </legend>

  <!-- class="border" -->
  <ng-container *ngFor="let key of getKeys(); let i = index">
    <!-- <span class="padded-bottom"> {{ getNameByCode(key) | titlecase }}</span> -->

    <div [formGroupName]="key" class="in-one-column">
      <mat-form-field>
        <app-easy-textarea
          formControlName="detailedDescription"
          [label]="
            'SHARED.LOCALIZED_MARKETING_SUBFORM.DETAILED_DESCRIPTION'
              | translate
          "
          [rows]="3"
          [resizable]="false"
        ></app-easy-textarea>
      </mat-form-field>

      <mat-form-field>
        <app-easy-input
          formControlName="videoLink"
          [label]="'SHARED.LOCALIZED_MARKETING_SUBFORM.VIDEO_LINK' | translate"
        >
        </app-easy-input>
      </mat-form-field>

      <mat-form-field [formGroup]="productInputs">
        <label>
          {{ "SHARED.LOCALIZED_MARKETING_SUBFORM.PRODUCT_TAGS" | translate }}
        </label>
        <input
          class="mb-3"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addTag($event, key)"
          [matChipInputAddOnBlur]="true"
        />
        <mat-chip-grid #chipList [formControlName]="key">
          <mat-chip-row
            *ngFor="let tag of productTags[key]"
            class="easy-chip"
            [attr.aria-readonly]="readOnly"
            (removed)="removeTag(tag, key)"
          >
            {{ tag }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        </mat-chip-grid>
      </mat-form-field>
    </div>
  </ng-container>
</fieldset>
